/**
 * * @module page/whatson.js
 */

import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import dotimeout from "../dotimeout";
import Filter from "../components/filter";

const AccessPerformances = Backbone.View.extend({
  el: $(document),

  events: {
    "click .section-title .accordion-item-title-button": "openMainAccordion",
  },

  initialize: function () {
    this.render();
  },

  setUpCollapsingSections: function () {
    if ($(window).width() < 769) {
      $("#section0").addClass("collapse").collapse("hide");
      $(".section .accordion-item-details")
        .addClass("collapse")
        .collapse("hide");
    } else {
      $(".section .accordion-item-details")
        .addClass("collapse")
        .collapse("show")
        .prev("button")
        .addClass("open");
    }
  },

  manageCollapsingSections: function () {
    $(".section .accordion-item-details").on("show.bs.collapse", function (e) {
      $(e.target).addClass("open");
      $(e.target).prev("button").addClass("open");
    });

    $(".section .accordion-item-details").on("hide.bs.collapse", function (e) {
      $(e.target).removeClass('open');
      $(e.target).prev("button").removeClass("open");
    });
  },

  openMainAccordion: function (e) {
    $("#section0").collapse("show");
    // $(".section .accordion-item-details").collapse("show");
    // $(e.target).hide();
    $(".filters-clear-button", $(e.target).parent().parent("h3")).show();
  },

  render: function () {
    this.filter = new Filter(
      ".all-events-list .event-block",
      ".article-body .events"
    );
    this.setUpCollapsingSections();
    this.manageCollapsingSections();
  },
});

export default AccessPerformances;
